import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useLang } from "@/context/LangContext";
import { pick } from "@/lib/insights";

const shortPillar = (p, lang) => {
  const s = pick(p, "pillar", lang) || p.pillar;
  const parts = s.split("–");
  return parts.length > 1 ? parts[1].trim() : s;
};

function ChartCard({ title, note, children, testid, height }) {
  const { lang } = useLang();
  return (
    <section className="bg-white rounded-[22px] p-5 sm:p-6" data-testid={testid}>
      <h3 className={`text-lg font-semibold text-[#1a1640] ${lang === "ta" ? "font-tamil" : "font-display"}`}>{title}</h3>
      <div className="mt-4" style={{ height }}>{children}</div>
      {note && <p className={`mt-2 text-[11.5px] text-[#8c89ad] ${lang === "ta" ? "font-tamil" : ""}`}>{note}</p>}
    </section>
  );
}

export default function PillarCharts({ pillars, allocationNote }) {
  const { t, lang } = useLang();
  const data = pillars.map((p) => ({ ...p, label: shortPillar(p, lang) }));
  const yWidth = lang === "ta" ? 150 : 130;
  const tick = { fontSize: 10.5, fill: "#1a1640" };
  const alloc = data.filter((p) => p.allocation_sum > 0).sort((a, b) => b.allocation_sum - a.allocation_sum);

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <ChartCard title={t("pillar_mix_title")} testid="pillar-mix-chart" height={380}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 0, right: 8 }}>
            <CartesianGrid horizontal={false} stroke="#eee" />
            <XAxis type="number" tick={{ fontSize: 11 }} />
            <YAxis type="category" dataKey="label" width={yWidth} tick={tick} interval={0} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="scheme" stackId="a" name={t("type_scheme")} fill="#1a1640" />
            <Bar dataKey="infrastructure" stackId="a" name={t("type_infrastructure")} fill="#2a9d8f" />
            <Bar dataKey="policy" stackId="a" name={t("type_policy")} fill="#f2b705" />
            <Bar dataKey="advocacy" stackId="a" name={t("type_advocacy")} fill="#e4572e" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
      <ChartCard title={t("alloc_title")} note={pick(allocationNote, "text", lang)} testid="allocation-chart" height={380}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={alloc} layout="vertical" margin={{ left: 0, right: 16 }}>
            <CartesianGrid horizontal={false} stroke="#eee" />
            <XAxis type="number" tick={{ fontSize: 11 }} tickFormatter={(v) => v.toLocaleString("en-IN")} />
            <YAxis type="category" dataKey="label" width={yWidth} tick={tick} interval={0} />
            <Tooltip formatter={(v) => `₹${v.toLocaleString("en-IN")} ${t("cr")}`} />
            <Bar dataKey="allocation_sum" name={t("allocation_label")} fill="#d62828" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>
  );
}
